import { render, staticRenderFns } from "./EigthPage.vue?vue&type=template&id=f22bd6e2&scoped=true"
import script from "./EigthPage.vue?vue&type=script&lang=js"
export * from "./EigthPage.vue?vue&type=script&lang=js"
import style0 from "./EigthPage.vue?vue&type=style&index=0&id=f22bd6e2&prod&lang=scss&scoped=true"
import style1 from "./EigthPage.vue?vue&type=style&index=1&id=f22bd6e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22bd6e2",
  null
  
)

export default component.exports